module.exports = __webpack_public_path__ + "static/media/SettingsActive.73c90c97.png";